module.exports = __webpack_public_path__ + "img/218M带纸顶.244.b38b6d2e.png";